import { pgTable, unique, date, uuid, text, foreignKey, real, jsonb, integer, boolean, index, } from 'drizzle-orm/pg-core';
import { BlockStatus, BlockType, TaskStatus } from '../../enums';
import { relations } from 'drizzle-orm';
import { isoTimestamp, sortOrder } from '../../utils';
import { orgTableBase, orgPrimaryKey } from '../org-id';
import { Track } from '../annual-planner';
import { TrainingFocus } from '../misc';
import { configColumn, printOptionDefaults, } from '../../json';
export const Block = pgTable('block', {
    ...orgTableBase,
    name: text('name').notNull(),
    blockType: BlockType('block_type').notNull().default('strength_training'),
    cycleLabel: text('cycle_label').notNull(),
    sessionLabel: text('session_label').notNull(),
    startDate: date('start_date').notNull(),
    endDate: date('end_date').notNull(),
    trainingMaxRatio: real('training_max_ratio').notNull(),
    trackId: uuid('track_id').notNull(),
    deletedAt: isoTimestamp('deleted_at'),
    layout: jsonb('layout').$type().notNull().default({}),
    status: BlockStatus('status').notNull().default('planned'),
    autoSchedule: boolean('auto_schedule').notNull().default(false),
    allowFlexWorkouts: boolean('allow_flex_workouts').notNull().default(false),
    hasPublishedWorkouts: boolean('has_published_workouts')
        .notNull()
        .default(false),
    hasWorkoutsInProgress: boolean('has_workouts_in_progress')
        .notNull()
        .default(false),
}, (table) => ({
    pk: orgPrimaryKey(table),
    trackFk: foreignKey({
        columns: [table.orgId, table.trackId],
        foreignColumns: [Track.orgId, Track.id],
    }),
    trackIdIdx: index('block_org_id_track_id_idx').on(table.orgId, table.trackId),
}));
// Block_Relations lives in ./relations.ts: it references AthletePublishedWorkoutLayer
// from ./workout, and importing ./workout from here would evaluate it before this
// module's `Block` is initialized (circular-import TDZ).
export const BlockFocus = pgTable('block_focus', {
    ...orgTableBase,
    sortOrder,
    focusId: uuid('focus_id').notNull(),
    blockId: uuid('block_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    blockFk: foreignKey({
        columns: [table.orgId, table.blockId],
        foreignColumns: [Block.orgId, Block.id],
    }),
    focusFk: foreignKey({
        columns: [table.orgId, table.focusId],
        foreignColumns: [TrainingFocus.orgId, TrainingFocus.id],
    }),
    uq1: unique().on(table.orgId, table.blockId, table.focusId),
    uq2: unique().on(table.orgId, table.blockId, table.sortOrder),
}));
export const BlockFocus_Relations = relations(BlockFocus, ({ one }) => ({
    block: one(Block, {
        fields: [BlockFocus.orgId, BlockFocus.blockId],
        references: [Block.orgId, Block.id],
    }),
    focus: one(TrainingFocus, {
        fields: [BlockFocus.orgId, BlockFocus.focusId],
        references: [TrainingFocus.orgId, TrainingFocus.id],
    }),
}));
export const BlockPrintTask = pgTable('block_print_task', {
    ...orgTableBase,
    blockId: uuid('block_id').notNull(),
    status: TaskStatus('status').notNull(),
    workoutIds: uuid('workout_ids').array().notNull(),
    profileIds: uuid('profile_ids').array().notNull(),
    pdfUrl: text('pdf_url'),
    printOptions: configColumn('print_options', printOptionDefaults).notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    blockFk: foreignKey({
        columns: [table.orgId, table.blockId],
        foreignColumns: [Block.orgId, Block.id],
    }),
}));
export const BlockPublishTask = pgTable('block_publish_task', {
    ...orgTableBase,
    blockId: uuid('block_id').notNull(),
    status: TaskStatus('status').notNull(),
    totalWorkouts: integer('total_workouts').notNull().default(0),
    completedWorkoutIds: uuid('completed_workout_ids').array().notNull(),
    failedWorkouts: jsonb('failed_workouts')
        // map of workoutId -> athleteIds
        .$type()
        .notNull()
        .default({}),
}, (table) => ({
    pk: orgPrimaryKey(table),
    blockFk: foreignKey({
        columns: [table.orgId, table.blockId],
        foreignColumns: [Block.orgId, Block.id],
    }),
}));
//# sourceMappingURL=index.js.map